import http from '@/services/http';
import { error } from '@/utils/safetyLog';
import axios from 'axios';

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;

export const getDefaultPromotion = async (productId?: string) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/quote/defaultPromotion/${productId}`);
    return response;
  } catch (e) {
    error('get default promotion error:', e);
    return null;
  }
};

export const getQuoteData = async (requestData: any, config?: any) => {
  try {
    const response = await http({}).post('/quote/detail', { ...requestData }, { ...config });
    return response;
  } catch (e) {
    error('get quote data error:', e);
    return null;
  }
};

export const getPromotionDetail = async (requestData: any) => {
  try {
    const response = await http({}).post('/quote/promotion', { ...requestData });
    return response;
  } catch (e) {
    error('get promotion detail error:', e);
    return null;
  }
};
